module.exports = __webpack_public_path__ + "img/file-earmark-code.bd6eead0.svg";